const allPrices = {
    namespaced: true,
    state: {
        activeTabIndex: 0
    },
    getters:{
        activeTabIndex: (state)=>{
            return state.activeTabIndex;
        },
        isExrack: (state)=>{
          return state.activeTabIndex === 0;
        },
        isBunkering: (state)=>{
          return state.activeTabIndex === 1;
        },
        isContract: (state)=>{
          return state.activeTabIndex === 2;
        },
        isDeliveredIn: (state)=>{
            return state.activeTabIndex === 3;
        },
    },
    actions: {
        selectTab({ commit }, payload){
            commit('SELECT_TAB', payload);
        }
    },
    mutations: {
        SELECT_TAB:(state, index)=>{
            state.activeTabIndex = index
        }
    }
}

export default allPrices